// cookies
export const ACCESS_TOKEN_COOKIE = 'ACCESS_TOKEN';
export const CITYDOMAIN_COOKIE = 'citydomain';
export const ID_TOKEN_COOKIE = 'ID_TOKEN';
export const AGREEMENT_ID_COOKIE = 'userId';
export const PROVIDER_ID_COOKIE = 'providerId';
export const COOKIE_MAX_AGE_LONG = 62 * 24 * 60 * 60;

// environment variables
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;

// AB-тесты
export const ABN_TEST_COOKIE = 'abn_test';
